const passenger = [
  // ── PRE-TRIP INSPECTION ───────────────────────────────────────────────────────
  {
    id: "pa001",
    question: "When inspecting a bus before driving, which interior items must you check?",
    options: [
      "Only the fare box and seats",
      "All emergency exits, emergency equipment, handrails, floor condition, and that all rider areas are safe",
      "Only the emergency exits",
      "Only the driver's compartment",
    ],
    answer: 1,
    explanation: "A thorough bus pre-trip inspection includes emergency exits, handrails, flooring, lighting, emergency equipment, and the entire passenger area.",
  },
  {
    id: "pa002",
    question: "During a bus pre-trip inspection, emergency exit doors must be:",
    options: [
      "Closed and locked at all times",
      "Checked that they open properly and are clearly marked",
      "Left slightly open for ventilation",
      "Checked only at the start of each week",
    ],
    answer: 1,
    explanation: "Emergency exits must open properly from inside and outside the bus, be clearly marked, and function without obstruction.",
  },
  {
    id: "pa003",
    question: "What must be checked on a bus's passenger entry door during the pre-trip inspection?",
    options: [
      "Only that it opens from the outside",
      "That it opens and closes properly, seals when closed, and the mechanism works correctly",
      "Only that the door is painted properly",
      "That it is always kept open while loading",
    ],
    answer: 1,
    explanation: "The entry door must open and close properly, seal correctly to prevent exhaust or fumes from entering, and operate smoothly.",
  },
  {
    id: "pa004",
    question: "Before a bus trip, what must you check regarding the intercom and public address system?",
    options: [
      "Only that it is turned on",
      "That it works properly for communicating with passengers",
      "Only that it is properly connected to a power source",
      "It is not required to be checked before every trip",
    ],
    answer: 1,
    explanation: "The PA/intercom system must work properly so you can communicate with passengers, especially during emergencies.",
  },
  {
    id: "pa005",
    question: "Seat backs on a bus must be checked to ensure they are:",
    options: [
      "Freshly cleaned",
      "Secure, not broken, and safe for passengers to lean against",
      "All the same color",
      "Only that front seats are secure",
    ],
    answer: 1,
    explanation: "Seat backs must be securely fastened and not broken so they provide proper support and do not become a hazard in a sudden stop.",
  },
  // ── LOADING AND UNLOADING PASSENGERS ─────────────────────────────────────────
  {
    id: "pa006",
    question: "When loading passengers at a bus stop, you should:",
    options: [
      "Allow passengers to board while the bus is still moving slowly",
      "Come to a complete stop, open doors only when safe, and supervise boarding",
      "Open doors before coming to a complete stop to save time",
      "Let passengers board from any door simultaneously",
    ],
    answer: 1,
    explanation: "The bus must be completely stopped before opening doors. Supervise boarding to ensure all passengers board safely before closing doors and moving.",
  },
  {
    id: "pa007",
    question: "When unloading passengers, you should:",
    options: [
      "Open the doors while still slowing down to save time",
      "Ensure the bus is completely stopped, check that it is safe to open the door, then supervise exiting",
      "Allow passengers to exit from both the front and emergency doors simultaneously",
      "Let passengers push the door open themselves",
    ],
    answer: 1,
    explanation: "Stop completely, check for hazards outside, then allow passengers to exit in an orderly fashion through the normal exit.",
  },
  {
    id: "pa008",
    question: "You should not leave your driver's seat while passengers are on board unless:",
    options: [
      "You need to check the back of the bus",
      "It is never acceptable to leave the seat with passengers on board",
      "You must address a safety issue in the passenger area, or in an emergency",
      "You need to open the luggage bay",
    ],
    answer: 2,
    explanation: "A driver should not leave the driving position while passengers are aboard unless a safety issue requires it. Never leave the vehicle unsecured with passengers.",
  },
  {
    id: "pa009",
    question: "When a passenger asks to be discharged at an unscheduled stop, you should:",
    options: [
      "Stop immediately wherever you are",
      "Explain company policy and discharge only at safe, designated locations",
      "Ignore the request and continue to the next scheduled stop",
      "Allow passengers to exit wherever requested",
    ],
    answer: 1,
    explanation: "Passengers should only be discharged at safe, designated locations per company policy. Stopping randomly in traffic or unsafe locations is dangerous.",
  },
  {
    id: "pa010",
    question: "What should you do if a passenger refuses to leave the bus?",
    options: [
      "Physically remove them yourself",
      "Continue driving with them on the bus regardless",
      "Request police assistance — do not physically handle a passenger",
      "Leave the bus yourself and call dispatch",
    ],
    answer: 2,
    explanation: "Never physically confront or remove a passenger. Contact your dispatcher and request law enforcement assistance.",
  },
  // ── HAZARDOUS MATERIALS AND PROHIBITED ITEMS ──────────────────────────────────
  {
    id: "pa011",
    question: "Which of the following items may NOT be transported on a passenger bus?",
    options: [
      "Luggage in overhead racks",
      "Firearms, explosives, or other hazardous materials not allowed on buses",
      "Small carry-on bags",
      "Strollers that are folded and secured",
    ],
    answer: 1,
    explanation: "Passengers may not bring hazardous materials, firearms (unless permitted by law), or other prohibited items on board a bus.",
  },
  {
    id: "pa012",
    question: "Flammable liquids may be carried on a bus:",
    options: [
      "In quantities up to 5 gallons",
      "Never — unless in a passenger's properly sealed container",
      "Only if the passenger keeps it with them at all times",
      "Never — flammable liquids are prohibited on buses carrying passengers",
    ],
    answer: 3,
    explanation: "Flammable liquids (gasoline, etc.) are never allowed on a bus carrying passengers. They pose an unacceptable fire risk.",
  },
  {
    id: "pa013",
    question: "A passenger boards carrying a package that appears to be leaking an unknown liquid. You should:",
    options: [
      "Allow them to board if they agree to keep it in the overhead",
      "Refuse to allow the package on the bus and report the situation",
      "Have the passenger store it in the luggage compartment",
      "Proceed and check the package later",
    ],
    answer: 1,
    explanation: "Unknown leaking substances may be hazardous. Refuse the package and report to dispatch or authorities for proper handling.",
  },
  // ── RAILROAD CROSSINGS ───────────────────────────────────────────────────────
  {
    id: "pa014",
    question: "A bus MUST stop at a railroad crossing:",
    options: [
      "Only if a train is visible",
      "Only if gates are down",
      "Always — with or without a train present, unless an exempt sign is posted",
      "Only at uncontrolled crossings",
    ],
    answer: 2,
    explanation: "Buses must always stop at railroad crossings (15–50 feet from the nearest rail), look and listen for trains, then proceed only when safe.",
  },
  {
    id: "pa015",
    question: "At a railroad crossing, when should a bus NOT stop?",
    options: [
      "When traffic is heavy",
      "When a 'Exempt' sign is posted indicating the crossing is not in use",
      "When the driver is confident no train is coming",
      "When in a residential neighborhood",
    ],
    answer: 1,
    explanation: "Buses may proceed without stopping only at crossings posted with a railroad 'Exempt' sign indicating the tracks are no longer in use.",
  },
  {
    id: "pa016",
    question: "While crossing railroad tracks, a bus driver should NOT:",
    options: [
      "Keep the bus in the same gear and maintain speed",
      "Change gears while the vehicle is on the tracks",
      "Turn off the radio to hear better",
      "Look in both directions before crossing",
    ],
    answer: 1,
    explanation: "Never change gears while crossing railroad tracks. A stall on the tracks can be fatal. Cross in a gear that will carry you completely across without shifting.",
  },
  {
    id: "pa017",
    question: "How far from the nearest rail should a bus stop before a railroad crossing?",
    options: [
      "At least 5 feet",
      "At least 15 feet but no more than 50 feet",
      "At least 100 feet",
      "Exactly 10 feet",
    ],
    answer: 1,
    explanation: "Stop 15–50 feet from the nearest rail track when required to stop at a railroad crossing.",
  },
  // ── EMERGENCY EXITS AND EVACUATION ───────────────────────────────────────────
  {
    id: "pa018",
    question: "When should you evacuate a bus?",
    options: [
      "Only when the driver is injured",
      "Whenever there is a danger of fire, being hit by another vehicle, or when remaining on the bus is more dangerous than evacuating",
      "Only when the rear door is blocked",
      "Always when stopped for more than 5 minutes",
    ],
    answer: 1,
    explanation: "Evacuate when the danger of staying on board (fire, collision risk, flooding, etc.) exceeds the risk of evacuating passengers.",
  },
  {
    id: "pa019",
    question: "Before evacuating a bus, you should:",
    options: [
      "Open the rear emergency exit only",
      "First check the area around the bus for hazards and choose the safest exit and route",
      "Immediately open all doors",
      "Wait for police before evacuating",
    ],
    answer: 1,
    explanation: "Before evacuating, assess the situation and hazards outside, choose the safest exit, and guide passengers to a safe location away from traffic.",
  },
  {
    id: "pa020",
    question: "When evacuating passengers from a bus due to a fire at the front, you should:",
    options: [
      "Use the front door since it is the nearest exit",
      "Use the rear emergency exit to move passengers away from the fire",
      "Wait for the fire to spread before deciding",
      "Have passengers jump from windows",
    ],
    answer: 1,
    explanation: "If fire is at the front, use the rear emergency exit to move passengers away from the danger.",
  },
  {
    id: "pa021",
    question: "After an emergency evacuation of a bus, passengers should be led to:",
    options: [
      "The side of the road directly behind the bus",
      "A safe location away from the bus and traffic — typically at least 100 feet from the vehicle",
      "Remain on the bus until help arrives",
      "Any nearby building",
    ],
    answer: 1,
    explanation: "Move passengers far enough away from the bus and traffic to prevent injury from explosion, fire, or oncoming vehicles.",
  },
  // ── PASSENGER MANAGEMENT ──────────────────────────────────────────────────────
  {
    id: "pa022",
    question: "A passenger is behaving in a way that distracts the driver. What should you do?",
    options: [
      "Ignore the passenger and focus on driving",
      "Address the situation safely — pull over if needed, use the intercom, or request law enforcement",
      "Stop the bus immediately in the lane of traffic",
      "Turn on loud music to drown out the distraction",
    ],
    answer: 1,
    explanation: "A distracted driver is a danger to all. Address passenger disruptions calmly — pull to a safe location if necessary and contact dispatch or police.",
  },
  {
    id: "pa023",
    question: "Passengers are allowed to stand:",
    options: [
      "Anywhere on the bus",
      "Only in designated standing areas when the bus is not full — never forward of the standee line",
      "Only in the rear of the bus",
      "Passengers may never stand on a moving bus",
    ],
    answer: 1,
    explanation: "Standees must remain behind the standee line (typically behind the front axle) on transit buses. On charter/motorcoach buses, no standing is permitted.",
  },
  {
    id: "pa024",
    question: "What should you do if a passenger becomes ill on the bus?",
    options: [
      "Continue to the next stop",
      "Stop in a safe location, assist the passenger, call for emergency medical help if needed",
      "Ask other passengers to help",
      "Ignore it unless the passenger falls unconscious",
    ],
    answer: 1,
    explanation: "Stop safely, render assistance, and call for emergency medical services if the situation warrants it.",
  },
  {
    id: "pa025",
    question: "When is it acceptable for a passenger bus driver to use a hand-held cell phone while driving?",
    options: [
      "When using a hands-free device for a quick call",
      "Only to call dispatch",
      "Never — hand-held cell phone use while driving a bus is prohibited",
      "When the bus is stopped at a traffic light",
    ],
    answer: 2,
    explanation: "Federal rules prohibit using a hand-held mobile phone while operating a CMV including buses. Hands-free devices are permitted, but distraction should always be minimized.",
  },
  // ── SCHOOL BUS OPERATIONS ─────────────────────────────────────────────────────
  {
    id: "pa026",
    question: "School bus danger zones are located:",
    options: [
      "Only behind the bus",
      "All areas within 10 feet of the bus — front, rear, and sides",
      "Only in front of the bus",
      "Only on the right side",
    ],
    answer: 1,
    explanation: "The danger zone is the area within 10 feet on all sides of the school bus — where students are most likely to be hit by the bus or another vehicle.",
  },
  {
    id: "pa027",
    question: "Where is the most dangerous area for a student near a school bus?",
    options: [
      "Behind the bus",
      "Inside the bus",
      "The area directly in front of the bus where the driver has the greatest blind spot",
      "The right side of the bus",
    ],
    answer: 2,
    explanation: "The area directly in front of the school bus is the most dangerous blind spot. Students who fall or drop something in front of the bus may not be seen by the driver.",
  },
  {
    id: "pa028",
    question: "Before a school bus moves from a stop, the driver must:",
    options: [
      "Check that all students are seated and the door is closed",
      "Honk once to alert students and move",
      "Wait exactly 30 seconds after closing the door",
      "Only check the left mirror",
    ],
    answer: 0,
    explanation: "Verify all students are safely seated and the entry door is fully closed before moving. Make a final scan of all mirrors.",
  },
  {
    id: "pa029",
    question: "When a school bus is stopped with red lights flashing and stop arm extended, traffic approaching from both directions must:",
    options: [
      "Stop only on the school bus side",
      "Slow to 15 mph",
      "Stop until the lights stop flashing and the bus moves or the driver signals it is safe to proceed",
      "Yield but may proceed at 10 mph",
    ],
    answer: 2,
    explanation: "All traffic from both directions must stop when a school bus shows flashing red lights and an extended stop arm — except on divided highways with physical barriers.",
  },
  {
    id: "pa030",
    question: "On a divided highway with a physical barrier (not just a painted median), other drivers must stop for a school bus with flashing red lights:",
    options: [
      "On both sides of the highway",
      "Only on the same side as the school bus — traffic on the opposite side of the barrier may proceed",
      "They do not need to stop at all",
      "Only if within 500 feet of the bus",
    ],
    answer: 1,
    explanation: "On a divided highway with a physical median barrier, traffic on the opposite side of the barrier is not required to stop for the school bus.",
  },
  {
    id: "pa031",
    question: "When picking up or dropping off students, a school bus driver should use the flashing amber (yellow) lights:",
    options: [
      "At every intersection",
      "As a warning to approaching traffic before activating the red lights for a stop",
      "Only in school zones",
      "Yellow lights are not used on school buses",
    ],
    answer: 1,
    explanation: "Flashing amber lights warn drivers that the school bus is about to stop. They should be activated 100–500 feet (depending on speed limit) before a student stop.",
  },
  {
    id: "pa032",
    question: "After students cross the road in front of a school bus, the driver should:",
    options: [
      "Move forward immediately after the last student steps off",
      "Count students to make sure all are visible and at least 10 feet away before proceeding",
      "Wait 30 seconds then move",
      "Flash headlights to signal it is safe and then proceed",
    ],
    answer: 1,
    explanation: "Confirm all students are a safe distance from the bus and visible before moving. Students may fall or turn back unexpectedly.",
  },
  {
    id: "pa033",
    question: "If a student drops something near the school bus, the driver should:",
    options: [
      "Tell the student to pick it up quickly",
      "Wait for the student to retrieve it before moving",
      "Ignore it and continue",
      "Have the student leave it and move the bus forward",
    ],
    answer: 1,
    explanation: "Students bending down to pick up items may go undetected in the bus's blind spots. Wait until the student has picked up the item and moved away before moving.",
  },
  {
    id: "pa034",
    question: "What is the school bus driver's responsibility during an emergency evacuation?",
    options: [
      "Get off the bus first to direct students",
      "Lead students out, count them, and move them to a safe location away from traffic",
      "Call parents before evacuating",
      "Only open the doors and let students decide where to go",
    ],
    answer: 1,
    explanation: "The driver leads and accounts for all students during evacuation, moving them to a safe location away from traffic and danger.",
  },
  {
    id: "pa035",
    question: "A school bus driver must perform a 'post-trip inspection' after every trip to:",
    options: [
      "Check fuel levels only",
      "Verify no sleeping children or left items are on the bus",
      "Complete the daily mileage log",
      "Report arrival time to dispatch",
    ],
    answer: 1,
    explanation: "Drivers must walk through the bus after every trip to check for sleeping children who may have been left behind. This is a life-safety requirement.",
  },
  // ── DRAWBRIDGES AND TUNNELS ───────────────────────────────────────────────────
  {
    id: "pa036",
    question: "A bus carrying passengers must stop before a drawbridge unless:",
    options: [
      "The driver can see the bridge is in the down position",
      "The bridge has a traffic signal or traffic control officer that shows green/clear and the draw is closed",
      "The bridge is within a city limit",
      "The driver has crossed the bridge before without incident",
    ],
    answer: 1,
    explanation: "Buses must stop before drawbridges unless a traffic signal or traffic control officer indicates the bridge is down and safe to cross.",
  },
  {
    id: "pa037",
    question: "When crossing a long bridge or tunnel with a bus full of passengers, you should:",
    options: [
      "Accelerate to get across quickly",
      "Maintain appropriate speed, follow all tunnel/bridge rules, and watch for any signs of hazards",
      "Open the passenger windows for ventilation",
      "Turn on the emergency lights",
    ],
    answer: 1,
    explanation: "Maintain safe speed, follow all posted rules, and monitor for any hazards or mechanical issues while crossing bridges and tunnels.",
  },
  // ── FUELING ───────────────────────────────────────────────────────────────────
  {
    id: "pa038",
    question: "When refueling a bus, passengers must:",
    options: [
      "Remain seated during fueling",
      "Exit the bus before fueling begins",
      "Move to the rear of the bus",
      "Only exit if there is a fire",
    ],
    answer: 1,
    explanation: "Passengers must exit the bus before fueling. Fuel vapors in an enclosed bus pose a serious fire and health hazard.",
  },
  {
    id: "pa039",
    question: "While fueling a bus, you should:",
    options: [
      "Leave the engine running to keep the air conditioning on for passengers",
      "Turn off the engine, ensure passengers are off, and avoid open flames or smoking",
      "Only turn off the engine if fueling with diesel",
      "Keep the passengers on board but in the back",
    ],
    answer: 1,
    explanation: "Turn off the engine, evacuate all passengers, and have no smoking or open flames near fuel. This applies to all bus types.",
  },
  // ── NIGHT OPERATIONS ──────────────────────────────────────────────────────────
  {
    id: "pa040",
    question: "When driving a bus at night, extra caution is needed because:",
    options: [
      "Passengers tend to be more noisy at night",
      "Visibility is reduced, headlights may not reveal all hazards, and fatigue is more likely",
      "Bus engines run hotter at night",
      "Traffic is always heavier at night",
    ],
    answer: 1,
    explanation: "Night driving reduces visibility, increases fatigue risk, and makes it harder to judge distances and identify hazards early.",
  },
  {
    id: "pa041",
    question: "If a passenger bus breaks down at night on a rural highway, the first thing you should do is:",
    options: [
      "Leave the bus to get help",
      "Turn on hazard flashers, keep passengers on board if safe, and place warning devices",
      "Have passengers walk to the nearest town",
      "Turn on all interior lights and wait",
    ],
    answer: 1,
    explanation: "Activate hazard lights, keep passengers on board if it is safe to do so, and place warning triangles or flares to protect the scene.",
  },
  // ── ADA AND ACCESSIBILITY ──────────────────────────────────────────────────────
  {
    id: "pa042",
    question: "When assisting a passenger in a wheelchair, you should:",
    options: [
      "Rush the boarding process to maintain the schedule",
      "Follow ADA procedures — properly deploy the lift, allow sufficient time, and secure the wheelchair",
      "Require the passenger to board without assistance",
      "Board the wheelchair passenger last to avoid delays",
    ],
    answer: 1,
    explanation: "ADA requires proper accommodation. Deploy the lift, allow adequate time, and secure the wheelchair in the designated area with all tie-downs.",
  },
  {
    id: "pa043",
    question: "Wheelchair securement systems must:",
    options: [
      "Only secure the front wheels",
      "Secure the wheelchair with a minimum of 4 tie-down points and include an occupant restraint",
      "Only use a seatbelt for the passenger",
      "Only prevent the wheelchair from rolling",
    ],
    answer: 1,
    explanation: "Wheelchairs must be secured with at least 4 anchor points (front and rear), and the occupant must be secured with a proper seatbelt system.",
  },
  // ── PASSENGER SAFETY RULES ────────────────────────────────────────────────────
  {
    id: "pa044",
    question: "Passengers must be seated before a bus moves. If a passenger is still boarding when you need to leave, you should:",
    options: [
      "Move slowly until they find a seat",
      "Wait until the passenger is safely seated before moving",
      "Close the doors and start moving",
      "Ask them to hold onto a handrail and proceed slowly",
    ],
    answer: 1,
    explanation: "Never move while a passenger is still boarding or standing in the aisle. Wait until everyone is safely seated.",
  },
  {
    id: "pa045",
    question: "What is the proper response if your bus is involved in a collision?",
    options: [
      "Drive to the nearest hospital",
      "Stop safely, secure the bus, check for injuries, call 911, protect the scene, and do not move the vehicle unless there is immediate danger",
      "Exchange insurance information and continue the route",
      "Move the bus off the road and wait for police",
    ],
    answer: 1,
    explanation: "Stop, secure the vehicle, assess injuries, call 911, and protect the scene. Do not move the vehicle unless it poses an immediate hazard.",
  },
  {
    id: "pa046",
    question: "Which of the following is true regarding smoking on a passenger bus?",
    options: [
      "Allowed in the back of the bus",
      "Allowed with passenger approval",
      "Prohibited — no smoking is allowed on passenger buses",
      "Allowed only for the driver",
    ],
    answer: 2,
    explanation: "Smoking is prohibited on passenger buses. This applies to both passengers and the driver.",
  },
  // ── CARGO ON PASSENGER VEHICLES ───────────────────────────────────────────────
  {
    id: "pa047",
    question: "Where should carry-on baggage on a bus be stored?",
    options: [
      "In the aisle where passengers can watch it",
      "In overhead storage or under the seat — never in the aisle where it could block evacuation",
      "Only in the luggage bay",
      "Passengers may hold bags on their laps only",
    ],
    answer: 1,
    explanation: "Carry-on baggage must be stored to prevent it from sliding into the aisle, blocking emergency exits, or becoming a projectile.",
  },
  {
    id: "pa048",
    question: "What must be checked at the luggage compartment (undercarriage) during a pre-trip inspection on a motorcoach?",
    options: [
      "Only that compartment doors open",
      "That doors latch securely, the compartment is clean, and items are not overweight or unsecured",
      "Only that luggage is present",
      "Nothing — the luggage is the passengers' responsibility",
    ],
    answer: 1,
    explanation: "Undercarriage compartment doors must latch securely. The driver is responsible for ensuring properly loaded and secured luggage compartments.",
  },
  // ── SECURITY AND EMERGENCY ────────────────────────────────────────────────────
  {
    id: "pa049",
    question: "If a passenger makes a bomb threat, you should:",
    options: [
      "Ignore it as a prank",
      "Evacuate passengers in an orderly fashion, park away from buildings and other vehicles, and call 911",
      "Search the bus yourself for a device",
      "Continue driving to a police station",
    ],
    answer: 1,
    explanation: "Treat all threats as real. Evacuate calmly, move the bus away from structures and people, and call 911 immediately.",
  },
  {
    id: "pa050",
    question: "If you suspect a passenger has a weapon, you should:",
    options: [
      "Confront the passenger directly",
      "Attempt to remove the weapon yourself",
      "Discreetly notify dispatch and law enforcement without provoking the individual",
      "Make a PA announcement warning other passengers",
    ],
    answer: 2,
    explanation: "Do not confront someone you suspect is armed. Quietly notify dispatch and law enforcement for a controlled, professional response.",
  },
  // ── GENERAL PASSENGER RULES ───────────────────────────────────────────────────
  {
    id: "pa051",
    question: "What should you do if passengers become rowdy or begin fighting?",
    options: [
      "Join in to restore order",
      "Pull over safely, turn on hazard lights, and contact law enforcement",
      "Ignore it and focus on driving",
      "Continue driving and announce a stern warning",
    ],
    answer: 1,
    explanation: "Pull over to a safe location, activate hazard lights, and call law enforcement. Do not attempt to physically intervene.",
  },
  {
    id: "pa052",
    question: "A bus may carry standees (standing passengers) only:",
    options: [
      "On motorcoaches (long-distance buses)",
      "At any time if there is room",
      "On transit buses in designated areas behind the standee line — never on motorcoaches",
      "Only during emergencies",
    ],
    answer: 2,
    explanation: "Motorcoaches (charter/long-distance buses) may not carry standees. Only transit buses can, and only in the designated standing area.",
  },
  {
    id: "pa053",
    question: "What is a 'standee line' on a transit bus?",
    options: [
      "A painted line marking the emergency exit",
      "A line painted on the floor marking the forward limit where standees may not stand",
      "The line separating the driver's compartment from the passenger area",
      "A safety line passengers must hold while standing",
    ],
    answer: 1,
    explanation: "The standee line is painted behind the front axle. Standing passengers must remain behind this line to avoid interfering with the driver.",
  },
  {
    id: "pa054",
    question: "What action should a bus driver take if the bus catches fire while passengers are on board?",
    options: [
      "Drive to the nearest fire station before evacuating",
      "Immediately notify passengers, stop at a safe location, and evacuate all passengers before fighting the fire",
      "Open all windows and continue to the next stop",
      "Park the bus and fight the fire while passengers remain seated",
    ],
    answer: 1,
    explanation: "Passenger safety is the top priority. Stop safely, evacuate all passengers immediately, then deal with the fire.",
  },
  {
    id: "pa055",
    question: "When approaching a school bus with flashing red lights from the front while driving your bus, you should:",
    options: [
      "Proceed slowly at 15 mph",
      "Stop — all traffic must stop for a school bus with flashing red lights",
      "Continue if you are a professional bus driver",
      "Honk to let the school bus driver know you are there",
    ],
    answer: 1,
    explanation: "All vehicles, including other buses, must stop for a school bus that is loading or unloading students with red lights flashing.",
  },
  {
    id: "pa056",
    question: "On a passenger bus, the number of riders must not exceed:",
    options: [
      "60 passengers for any bus",
      "The seating capacity listed on the vehicle's registration",
      "40 passengers at any time",
      "Any limit — as long as everyone is standing safely",
    ],
    answer: 1,
    explanation: "Buses must not carry more passengers than their rated capacity (GVWR and seating capacity shown on registration and manufacturer's plate).",
  },
  {
    id: "pa057",
    question: "Why is it important to know the clearance height of the bus you are driving?",
    options: [
      "To determine fuel consumption",
      "To avoid striking overhead obstacles such as bridges, signs, and low clearances",
      "To comply with weight limits",
      "It is only important for school buses",
    ],
    answer: 1,
    explanation: "Buses have high profiles. Knowing the exact height prevents striking bridges, canopies, and overhead obstacles that appear to have sufficient clearance.",
  },
  {
    id: "pa058",
    question: "At bus stops, you should not allow passengers to stand in the doorway because:",
    options: [
      "It blocks the driver's view of the mirror",
      "Standing in the doorway exposes them to injury from moving vehicles and prevents the door from closing safely",
      "It is against company appearance standards",
      "The door sensors may malfunction",
    ],
    answer: 1,
    explanation: "Passengers in the doorway are at extreme risk from passing traffic. The door must be fully closed before the bus moves.",
  },
  {
    id: "pa059",
    question: "What does it mean when the 'door interlock' system prevents bus movement?",
    options: [
      "The bus needs refueling",
      "A door is not fully closed — the interlock prevents the bus from moving with an open door",
      "The parking brake is engaged",
      "The ABS is malfunctioning",
    ],
    answer: 1,
    explanation: "Door interlocks are a safety feature that prevents the bus from moving when a door is open. If the bus won't move, check that all doors are fully closed.",
  },
  {
    id: "pa060",
    question: "How should you respond if an emergency vehicle approaches from behind while you are driving a bus full of passengers?",
    options: [
      "Stop immediately in the lane of traffic",
      "Pull over to the right as safely and quickly as possible, stop, and wait for the emergency vehicle to pass",
      "Speed up to get out of the way",
      "Stay in your lane and activate hazard lights",
    ],
    answer: 1,
    explanation: "Pull to the right, stop, and allow the emergency vehicle to pass. Buses follow the same 'yield and pull over' rules as all other vehicles.",
  },
  {
    id: "pa061",
    question: "If your bus becomes disabled on railroad tracks with passengers aboard, you should:",
    options: [
      "Keep passengers on board and call for a tow truck",
      "Immediately evacuate all passengers away from the tracks in the direction of any approaching train",
      "Wait to see if a train is coming before evacuating",
      "Try to push the bus off the tracks manually",
    ],
    answer: 1,
    explanation: "Get everyone off the bus immediately. Move them away from the tracks — perpendicular to the tracks — in the direction from which a train would approach, so they are not hit by debris if a collision occurs.",
  },
  {
    id: "pa062",
    question: "When passengers are boarding, the bus should be:",
    options: [
      "Moving slowly to save time",
      "Completely stopped, with the parking brake set or brake held firmly",
      "In neutral with the engine off",
      "Pulled to the center of the lane",
    ],
    answer: 1,
    explanation: "The bus must be completely stationary when passengers are boarding or exiting. Set the parking brake or hold the service brake firmly.",
  },
  {
    id: "pa063",
    question: "What is the purpose of the 'danger zone' concept around a school bus?",
    options: [
      "To define the area where the bus engine runs hottest",
      "To identify the area where children are most at risk of being struck by the bus or other vehicles",
      "To define the legal stopping area for the bus",
      "To mark the area around the exhaust pipes",
    ],
    answer: 1,
    explanation: "The danger zone marks the area where children are most vulnerable — within 10 feet of the bus on all sides — where the driver's view is most limited.",
  },
  {
    id: "pa064",
    question: "Which of the following best describes the proper handling of a medical emergency on a bus?",
    options: [
      "Ask other passengers to handle it while you keep driving",
      "Pull over safely, assess the situation, call 911, and provide basic assistance if trained",
      "Announce on the PA for a doctor on board and continue driving",
      "Drive directly to a hospital at maximum speed",
    ],
    answer: 1,
    explanation: "Stop safely, assess the passenger's condition, call 911 for professional medical help, and provide first aid within your training level.",
  },
  {
    id: "pa065",
    question: "A child drops a backpack near the front of the school bus as they exit. The driver should:",
    options: [
      "Tell the child to hurry and pick it up, then move immediately",
      "Honk to alert the child and proceed once they look up",
      "Wait until the child retrieves it and is safely away from the bus before moving",
      "Have another student pick it up",
    ],
    answer: 2,
    explanation: "Wait until the child has retrieved the item, is visible, and is a safe distance from the bus before moving. Children bending down enter the driver's blind spot.",
  },
  {
    id: "pa066",
    question: "Which of the following items must be inspected on the exterior of a bus during the pre-trip inspection?",
    options: [
      "Only tires and lights",
      "Tires, wheels, mirrors, lights, reflectors, body condition, and undercarriage",
      "Only the mirrors and body panels",
      "Only the emergency exits",
    ],
    answer: 1,
    explanation: "A complete exterior inspection includes tires, wheels, lights, mirrors, reflectors, body condition, leaks, and undercarriage — the same as for any CMV.",
  },
  {
    id: "pa067",
    question: "What is the purpose of the 'stop arm' on a school bus?",
    options: [
      "To signal other buses at a terminal",
      "To signal other drivers that they must stop while students are loading or unloading",
      "To provide additional lighting at night",
      "To warn of a low-bridge ahead",
    ],
    answer: 1,
    explanation: "The stop arm swings out from the left side of the bus with flashing lights to legally require all nearby traffic to stop while students are loading or unloading.",
  },
  {
    id: "pa068",
    question: "If a student is approaching the bus from across the street, the driver should:",
    options: [
      "Open the door and allow the student to cross when no cars are visible",
      "Wait for the student to cross only after the stop arm and red lights are activated and you have verified it is safe",
      "Honk to hurry the student",
      "Wait until the student reaches the bus door, then activate the stop arm",
    ],
    answer: 1,
    explanation: "Activate stop lights and arm before students cross. Verify oncoming traffic has stopped before allowing students to cross.",
  },
  {
    id: "pa069",
    question: "A passenger reports seeing smoke from the rear of the bus. You should:",
    options: [
      "Ask the passenger to investigate",
      "Check the mirror and pull over immediately to assess the situation safely",
      "Turn on the fans to dissipate the smoke and continue",
      "Stop only if you also see the smoke",
    ],
    answer: 1,
    explanation: "Any report of smoke must be taken seriously. Check mirrors, pull over safely, and investigate — smoke can indicate a fire or mechanical failure.",
  },
  {
    id: "pa070",
    question: "How many emergency exits must a passenger bus have?",
    options: [
      "Only one — the main entry door",
      "At least one rear emergency exit in addition to the main door, with more required for larger buses per FMVSS requirements",
      "Two — one on each side",
      "Emergency exits are optional on small buses",
    ],
    answer: 1,
    explanation: "Buses must have emergency exits (rear door, windows, roof hatches) that meet federal standards based on the number of passengers and vehicle size.",
  },
  {
    id: "pa071",
    question: "What is the 'safe haven' concept for school buses?",
    options: [
      "A designated inspection area for buses",
      "A location where a school bus driver may stop in an emergency if they feel threatened or unsafe",
      "A parking area for buses after routes",
      "A bus maintenance facility",
    ],
    answer: 1,
    explanation: "A safe haven is a pre-identified, safe location (police station, fire station, school) where a bus driver can go if they feel threatened or have an emergency.",
  },
  {
    id: "pa072",
    question: "Which of the following is the correct action when a passenger bus is involved in an accident that results in an injury?",
    options: [
      "Only contact the company's insurance provider",
      "Secure the scene, call 911, provide first aid if trained, do not move passengers unless necessary, notify dispatch, and complete required accident reports",
      "Drive all injured passengers to a hospital",
      "Allow passengers to leave the scene and file individual police reports",
    ],
    answer: 1,
    explanation: "An injury accident requires: 911 call, scene security, first aid if trained, not moving injured persons, dispatch notification, and completion of all required reports.",
  },
  {
    id: "pa073",
    question: "A passenger on a bus must wear a seatbelt:",
    options: [
      "At all times on all buses",
      "Only on school buses",
      "Where seats are equipped with them and law requires their use (varies by vehicle type and state law)",
      "Only during emergencies",
    ],
    answer: 2,
    explanation: "Seatbelt requirements for passengers vary by vehicle type and state. Motorcoaches often have them. School buses use compartmentalization rather than seatbelts unless the state requires them.",
  },
  {
    id: "pa074",
    question: "When should a bus driver report a student who is not at the regular stop?",
    options: [
      "After completing the entire route",
      "Immediately — report to dispatch or school officials if a student who normally boards is absent",
      "Only if the student is absent for multiple days",
      "It is not the driver's responsibility",
    ],
    answer: 1,
    explanation: "Missing students may be a safety concern. Report any unexpected absence of regular riders to the school or dispatch immediately.",
  },
  {
    id: "pa075",
    question: "When a passenger bus is required to stop at a railroad crossing, which step comes LAST?",
    options: [
      "Open the service door to listen for trains",
      "Look both ways for approaching trains",
      "Ensure there is room to fully clear the tracks on the other side, then cross",
      "Stop 15–50 feet from the nearest rail",
    ],
    answer: 2,
    explanation: "The proper sequence: stop 15–50 feet from the tracks → open door to listen → look both ways → confirm space on the other side → cross without shifting gears.",
  },
  // ── UPDATED / ADDITIONAL CONCEPTS 2025-2026 ──────────────────────────────────
  {
    id: "pa076",
    question: "Under ADA requirements, when a passenger with a mobility device boards a lift-equipped bus, the driver must:",
    options: [
      "Allow the passenger to board only if they can fold the mobility device",
      "Ensure the lift is operational, assist as needed, and secure the mobility device with the securement system before moving the vehicle",
      "Charge an additional fare for wheelchair passengers",
      "Only accept manual wheelchairs, not power chairs",
    ],
    answer: 1,
    explanation: "ADA requires that passengers with mobility devices be accommodated. The driver must use the lift, provide assistance, and securely anchor the mobility device using the vehicle's securement system before moving.",
  },
  {
    id: "pa077",
    question: "When a passenger uses a wheelchair on a bus, the wheelchair must be secured using:",
    options: [
      "Only the passenger's lap belt",
      "A four-point tie-down system or other FMVSS-compliant securement that prevents the chair from moving in any direction",
      "A standard cargo strap rated for 500 lbs",
      "The bus's overhead luggage rack system",
    ],
    answer: 1,
    explanation: "Wheelchairs must be secured with a four-point tie-down system (forward-facing or rear-facing) that restrains the chair from moving forward, backward, and laterally. The occupant should also use a lap and shoulder belt if available.",
  },
  {
    id: "pa078",
    question: "A bus driver observes a passenger who appears to be having a medical emergency. The driver should:",
    options: [
      "Continue the route and notify the next stop attendant",
      "Stop the bus safely, call 911, notify dispatch, and provide first aid only if trained — do not move the passenger unless there is immediate danger",
      "Ask other passengers to assist and continue the route",
      "Drive directly to the nearest hospital without calling 911",
    ],
    answer: 1,
    explanation: "Stop the bus in a safe location, call 911 immediately, notify dispatch, and provide first aid if you are trained. Do not attempt to move an injured or ill person unless they are in immediate danger.",
  },
  {
    id: "pa079",
    question: "What is the correct procedure when a bus driver suspects a passenger has left an unattended bag or package on the bus?",
    options: [
      "Move the item to the lost-and-found bin at the next stop",
      "Do not touch the item; treat it as a potential security threat — notify dispatch and law enforcement and follow the carrier's security procedures",
      "Ask other passengers if the bag belongs to them",
      "Place the bag outside the bus at the next stop",
    ],
    answer: 1,
    explanation: "Unattended packages are a potential security threat. Never handle or move a suspicious item. Notify dispatch and local law enforcement, secure the area, and follow your carrier's emergency security plan.",
  },
  {
    id: "pa080",
    question: "Under FMCSA regulations, a bus driver must inspect the bus after completing a route or trip for:",
    options: [
      "Only mechanical defects under the hood",
      "Sleeping or hidden stowaways, unattended packages, and any items left behind — especially in luggage compartments",
      "Cleanliness and appearance only",
      "Fare collection equipment only",
    ],
    answer: 1,
    explanation: "Post-trip inspections of passenger compartments and luggage bays are required to find stowaways, unattended bags, or lost items, and to check for damage or defects that need reporting.",
  },
  {
    id: "pa081",
    question: "When a bus driver must evacuate passengers, what is the safest direction to move them?",
    options: [
      "To the nearest building, regardless of direction",
      "Away from the bus and toward the side of the road — at least 100 feet — upwind of any fire or hazmat, and away from traffic",
      "Directly across the road to the opposite sidewalk",
      "Passengers should stay on the bus unless there is a fire",
    ],
    answer: 1,
    explanation: "Move evacuated passengers at least 100 feet away from the bus, upwind and away from traffic. Keep them together in a safe area and prevent them from returning to the vehicle.",
  },
  {
    id: "pa082",
    question: "What is the maximum number of standees (standing passengers) allowed on a transit bus?",
    options: [
      "Standing passengers are never permitted on any bus",
      "As many as the aisle will hold",
      "Only the number specified by the manufacturer's maximum occupancy rating — the vehicle must not exceed this limit",
      "Up to 20 standees regardless of vehicle size",
    ],
    answer: 2,
    explanation: "The number of standees is limited by the manufacturer's maximum occupancy (standee line) marking. Exceeding this limit is a federal violation. The standee line is marked inside the bus near the front.",
  },
  {
    id: "pa083",
    question: "What is the 'standee line' on a transit bus?",
    options: [
      "A line on the floor marking the fare payment zone",
      "A painted or marked line behind the driver that passengers must not stand forward of while the bus is moving",
      "A line on the seat backs indicating maximum recline",
      "A floor marking showing the wheelchair securement zone",
    ],
    answer: 1,
    explanation: "The standee line is marked near the front of the bus. No standing passengers may occupy the area forward of this line while the bus is in motion, to protect the driver and ensure visibility.",
  },
  {
    id: "pa084",
    question: "When transporting passengers, a driver must NOT carry which of the following in the passenger compartment?",
    options: [
      "Carry-on luggage under 50 lbs",
      "Division 2.3 poison gases, Division 6.1 poisons, Division 7 radioactive materials — and other hazmat prohibited in the passenger compartment",
      "Small electronic devices",
      "Medical oxygen in portable tanks",
    ],
    answer: 1,
    explanation: "Certain hazmat classes are prohibited in the passenger area of a bus. These include most gases, poisons, radioactive materials, and explosives. Small quantities of some hazmat may be transported as carry-on luggage under specific conditions.",
  },
  {
    id: "pa085",
    question: "A bus driver notices that a passenger is behaving in a way that endangers other passengers. The driver should:",
    options: [
      "Ignore the behavior unless it becomes violent",
      "Ask the passenger to comply with safety rules; if they refuse, stop at a safe location and have the passenger removed — contact dispatch or law enforcement as needed",
      "Speed up to reach the next stop faster",
      "Allow other passengers to handle the situation",
    ],
    answer: 1,
    explanation: "The driver is responsible for passenger safety. Address the behavior calmly and firmly. If the passenger refuses to comply, stop safely and have them removed. Do not attempt to physically restrain a passenger.",
  },
  {
    id: "pa086",
    question: "Under FMCSA rules, a bus that transports passengers for hire must have which of the following on board at all times?",
    options: [
      "A GPS unit and a spare tire",
      "A first aid kit, fire extinguisher, and emergency reflectors or flares",
      "A food and water supply for emergencies",
      "Only a fire extinguisher",
    ],
    answer: 1,
    explanation: "Buses must carry emergency equipment including a fire extinguisher (properly charged), first aid kit, and emergency reflectors (or other warning devices). These must be in serviceable condition.",
  },
  {
    id: "pa087",
    question: "At what minimum distance must a bus driver stop before a drawbridge that does not have a signal or traffic control device?",
    options: [
      "25 feet from the draw",
      "50 feet from the draw",
      "100 feet from the draw",
      "No stop is required — only slow down",
    ],
    answer: 1,
    explanation: "Bus drivers must stop at least 50 feet before a drawbridge if there is no traffic control signal, signal person, or bridge tender to direct traffic.",
  },
  {
    id: "pa088",
    question: "What is the purpose of the 'interlock system' on some transit buses?",
    options: [
      "To prevent the engine from starting unless seatbelts are fastened",
      "To prevent the bus from moving until the doors are fully closed, or to prevent the doors from opening while the bus is moving above a set speed",
      "To lock the steering when the parking brake is applied",
      "To disable the engine if brake pressure falls below 60 psi",
    ],
    answer: 1,
    explanation: "The door interlock prevents the bus from moving while the doors are open, and prevents doors from opening while the bus is in motion above a set speed. This protects passengers from falls and reduces boarding accidents.",
  },
  {
    id: "pa089",
    question: "When must a driver check mirrors for passengers who may be crossing behind the bus after stopping?",
    options: [
      "Only at designated crosswalks",
      "Before closing the doors and moving — always check all mirrors to ensure no passengers are in the danger zone around the vehicle",
      "Only in school zone areas",
      "Mirrors only need to be checked before entering traffic, not for pedestrians",
    ],
    answer: 1,
    explanation: "Before moving, always scan all mirrors to check for passengers who may be crossing behind or alongside the bus. A passenger who just exited may step back into the roadway or walk in the bus's path.",
  },
  {
    id: "pa090",
    question: "Which of the following statements about fueling a bus with passengers on board is correct?",
    options: [
      "Passengers may remain on board during fueling if the engine is off",
      "Passengers must not be on board while the bus is being fueled — all passengers must exit before fueling begins",
      "Fueling with passengers on board is allowed in all situations",
      "Passengers may remain on board if fueling takes less than five minutes",
    ],
    answer: 1,
    explanation: "Passengers must be off the bus before fueling. Fueling with passengers aboard creates a fire risk from fuel vapors. This rule applies to all passenger-carrying buses.",
  },
  // ── MBTA PASSENGER ENDORSEMENT TEST 1 ────────────────────────────────────────
  {
    id: "pa091",
    question: "Carrying hazardous materials on a bus is: (4.2.2)",
    options: [
      "Permitted if the material's container is placarded",
      "Permitted if they meet certain conditions",
      "Never permitted",
    ],
    answer: 1,
    explanation: "Buses may carry certain hazardous materials in limited quantities if they meet specific conditions — some hazmat classes are always forbidden on buses.",
  },
  {
    id: "pa092",
    question: "To stop for railroad tracks, a bus driver should stop ___ to ___ feet before the nearest track. (4.3.5)",
    options: ["5 to 20", "10 to 35", "15 to 50"],
    answer: 2,
    explanation: "At railroad crossings, stop the bus no closer than 15 feet and no farther than 50 feet from the nearest rail.",
  },
  {
    id: "pa093",
    question: "While driving a bus, a bus driver: (4.5)",
    options: [
      "Can only talk with riders if cruising on a highway",
      "Should only allow riders to talk to you only if they can stay in their seat",
      "Should never talk unnecessarily with riders",
    ],
    answer: 2,
    explanation: "Bus drivers must not talk unnecessarily with passengers while driving — conversations distract from safely operating the vehicle.",
  },
  {
    id: "pa094",
    question: "Buses may have recapped or re-grooved tires: (2.1.3)",
    options: [
      "Anywhere except the front wheels",
      "On any or all of the wheels",
      "Only on the outside of duals",
    ],
    answer: 0,
    explanation: "Recapped or re-grooved tires may be used on any bus wheel position except the front (steering) axle, where only new tires are permitted.",
  },
  {
    id: "pa095",
    question: "Which of these will result in the best control on curves? (2.6.3)",
    options: [
      "Brake in the curves and accelerate out",
      "Slow to a safe speed before entering curves, then accelerate slightly in the curves",
      "Slow to a safe speed before entering curves, then coast through them",
    ],
    answer: 1,
    explanation: "Slow to a safe speed before entering a curve, then accelerate gently through it. This keeps the vehicle stable and maintains traction.",
  },
  {
    id: "pa096",
    question: "When driving a bus across railroad tracks you: (2.15.5)",
    options: [
      "Do not have to stop, but must slow down at tracks where the crossing gates are in the upright position",
      "May sometimes need to stop more than 75 feet from the tracks",
      "Should never change gears if your bus has a manual transmission",
    ],
    answer: 2,
    explanation: "Never change gears while crossing railroad tracks — stalling on the tracks is extremely dangerous. Complete the crossing in the gear you start with.",
  },
  {
    id: "pa097",
    question: "You should not let riders stand: (4.2.3)",
    options: [
      "In front of the standee line",
      "Between the wheel wells",
      "Within two feet of an emergency exit",
    ],
    answer: 0,
    explanation: "Standees must stand behind the standee line — no passengers are allowed to stand forward of that line while the bus is in motion.",
  },
  {
    id: "pa098",
    question: "If you work for an interstate carrier, you must complete an after-trip inspection report that specifies, for each bus: (2.1.5)",
    options: [
      "Any defects that would affect safety or result in a breakdown",
      "Fuel usage, distance traveled, and mileage for that trip",
      "Any problems that occurred with riders",
    ],
    answer: 0,
    explanation: "After-trip inspection reports must document any defect or deficiency that would affect safe operation or result in a breakdown, so the carrier can ensure repairs before the next trip.",
  },
  {
    id: "pa099",
    question: "Which of these statements about managing space to the sides of your bus is true? (2.7.3)",
    options: [
      "You should keep your bus to the right side of your lane",
      "You should avoid traveling next to others when possible",
      "You should keep your bus to the left side of your lane",
    ],
    answer: 1,
    explanation: "Avoid traveling alongside other vehicles — if possible, change lanes to keep space on both sides. Being boxed in limits your escape options.",
  },
  {
    id: "pa100",
    question: "A bus may carry baggage and freight only if it is: (4.2)",
    options: [
      "Stored in a separate baggage or freight compartment",
      "Owned by a riding passenger",
      "Secured and out of the way of any exit",
    ],
    answer: 2,
    explanation: "Baggage or freight must be secured so it cannot move and must not block any exit, aisle, or emergency equipment.",
  },
  {
    id: "pa101",
    question: "Baggage or freight carried on a bus must be secured: (4.2)",
    options: [
      "In a separate compartment away from passengers",
      "In front of the standee line",
      "So any door or window can be used in an emergency",
    ],
    answer: 2,
    explanation: "All baggage and freight must be stowed so that every door, window, and emergency exit remains fully usable in an emergency.",
  },
  {
    id: "pa102",
    question: "When is it OK to drive with an emergency exit door open? (4.1.3)",
    options: [
      "It is never OK to drive with an emergency exit door open",
      "When you will only be moving a short distance",
      "If the temperature in the cabin is uncomfortably hot",
    ],
    answer: 0,
    explanation: "Emergency exit doors must always be fully closed while the bus is in motion — there are no exceptions.",
  },
  {
    id: "pa103",
    question: "If you have riders aboard, you should never fuel your bus: (4.5)",
    options: [
      "Without a fire extinguisher beside you",
      "In a closed building",
      "With any of the windows open",
    ],
    answer: 1,
    explanation: "Never fuel a bus with passengers aboard inside a closed building — fuel vapors can accumulate and ignite, posing a serious fire and explosion risk.",
  },
  {
    id: "pa104",
    question: "Charter bus drivers should not allow riders on the bus until: (4.2.4)",
    options: [
      "All baggage has been loaded",
      "All scheduled passengers have arrived at the station",
      "Departure time",
    ],
    answer: 2,
    explanation: "For charter operations, passengers should not board until departure time to keep the bus secure and organized.",
  },
  {
    id: "pa105",
    question: "You are driving at night and you must dim your headlights from high to low. What should you do with your speed? (2.11.4)",
    options: [
      "Drop 5 mph until your eyes adjust",
      "Slow down",
      "Nothing. How well you can see should not affect your speed",
    ],
    answer: 1,
    explanation: "When you switch to low beams, your visibility decreases. Slow down so your stopping distance stays within the range you can see.",
  },
  {
    id: "pa106",
    question: "If your bus has an emergency exit door, it must: (4.1.3)",
    options: [
      "Be closed when operating the bus",
      "Always have a red door light on",
      "Sound an alarm when opened",
    ],
    answer: 0,
    explanation: "The emergency exit door must be closed at all times when the bus is being operated — it is only for use in emergencies.",
  },
  {
    id: "pa107",
    question: "Buses are allowed to carry less than 100 pounds of ___ in the passenger area. (4.2.2)",
    options: [
      "Small arms ammunition (ORM-D)",
      "Labeled radioactive materials",
      "Liquid Class 6 poisons",
    ],
    answer: 0,
    explanation: "Buses may carry small arms ammunition classified as ORM-D in quantities under 100 pounds in the passenger area. Radioactive materials and Class 6 liquid poisons are not permitted.",
  },
  {
    id: "pa108",
    question: "You are driving a 40-foot bus at 30 mph. The road is dry and visibility is good. You should keep a safety space in front of your bus that is at least ___ seconds. (2.7.1)",
    options: ["8", "4", "3"],
    answer: 1,
    explanation: "At 30 mph in good conditions, a 40-foot bus requires at least 4 seconds of following distance. Add 1 second for each 10 feet of vehicle length over 40 feet.",
  },
  {
    id: "pa109",
    question: "Which of these statements about seeing ahead is true? (2.4.1)",
    options: [
      "Good drivers shift their attention back and forth, near and far",
      "Good drivers keep their attention on one place for 12-15 seconds at a time",
      "At highway speeds, you should look 3-5 seconds ahead of you",
    ],
    answer: 0,
    explanation: "Good drivers continuously shift their eyes — scanning near and far, sides and mirrors — rather than fixating on one point.",
  },
  {
    id: "pa110",
    question: "When are you required to wear a seatbelt?",
    options: [
      "Only when transporting passengers",
      "Only when you are driving on the highway",
      "Always",
    ],
    answer: 2,
    explanation: "CDL holders are required to wear a seatbelt at all times when operating a commercial motor vehicle, regardless of route or passenger load.",
  },
  {
    id: "pa111",
    question: "Your bus is disabled. A bus with riders aboard may be towed or pushed to a safe spot to discharge the passengers only: (4.5)",
    options: [
      "If the distance is less than 1 mile",
      "If getting off the bus sooner would be unsafe",
      "By another bus with its 4-way flashers on",
    ],
    answer: 1,
    explanation: "A disabled bus with passengers may only be moved to a safe discharge point if it is unsafe for passengers to exit at the current location.",
  },
  {
    id: "pa112",
    question: "Many buses have curved (convex or 'spot') mirrors. These mirrors: (2.4)",
    options: [
      "Are against the law in some states",
      "Make things seem smaller and farther away than they really are",
      "Do not need to be checked often because they show a larger area",
    ],
    answer: 1,
    explanation: "Convex (spot) mirrors give a wider field of view but make objects appear smaller and farther away than they actually are.",
  },
  {
    id: "pa113",
    question: "A hazard is defined as: (2.8)",
    options: [
      "Another driver",
      "A condition of the roadway or weather",
      "Any condition which may cause your trip to be unsafe",
    ],
    answer: 2,
    explanation: "A hazard is broadly defined as any road condition, user, or other circumstance that presents a potential danger to you or others.",
  },
  {
    id: "pa114",
    question: "If a rider wants to bring a car battery or a can of gasoline aboard your bus, you should: (4.2.2)",
    options: [
      "Not allow the rider to do it",
      "Tell the rider to sit in the rear of the bus",
      "Put the battery or gasoline in the cargo compartment",
    ],
    answer: 0,
    explanation: "Flammable liquids (gasoline) and batteries that can spill acid are prohibited from buses. You must not allow these items aboard.",
  },
  {
    id: "pa115",
    question: "When waiting to pull out into traffic, you should: (4.2.3)",
    options: [
      "Always wait for the proper gap",
      "Pull out slowly",
      "Drive on the shoulder until you reach the speed of traffic",
    ],
    answer: 0,
    explanation: "Always wait for an adequate gap in traffic before pulling out. Never force your way into moving traffic.",
  },
  {
    id: "pa116",
    question: "A standee line on a bus: (4.2.3)",
    options: [
      "Is required when carrying less than 15 riders",
      "Indicates where you should stand when you are talking to the passengers",
      "Is the line that all riders must stay behind while the bus is moving",
    ],
    answer: 2,
    explanation: "The standee line is painted on the floor near the front of the bus. All standing passengers must remain behind this line while the bus is in motion.",
  },
  {
    id: "pa117",
    question: "You may sometimes transport small arms ammunition or emergency hospital supplies on a bus. The total weight of all such hazardous materials must not be more than ___ pounds. (4.2.2)",
    options: ["5", "50", "500"],
    answer: 2,
    explanation: "The total weight of all allowable hazardous materials (such as small arms ammunition ORM-D or hospital supplies) carried in the passenger area must not exceed 500 pounds.",
  },
  {
    id: "pa118",
    question: "When you arrive at a bus stop, you should announce the: (4.2.4)",
    options: [
      "Reason for stopping, next departure time, estimated time of arrival (ETA) next destination, and the length of time until passengers may board the bus",
      "Reason for stopping, ETA of arrival for next destination, and the bus number",
      "Location, reason for stopping, next departure time, and the bus number",
    ],
    answer: 2,
    explanation: "When arriving at a bus stop, announce the location, reason for stopping, next departure time, and the bus number so passengers have the information they need.",
  },
  {
    id: "pa119",
    question: "You should check your mirrors: (4.2)",
    options: [
      "Right after starting a lane change",
      "As you are preparing to stop",
      "Regularly as part of your scan for potential hazards",
    ],
    answer: 2,
    explanation: "Mirrors should be checked regularly and continuously as part of your overall scanning routine, not just at specific moments.",
  },
  {
    id: "pa120",
    question: "Carry-on baggage: (4.2.4)",
    options: [
      "Always needs to be stored in the overhead compartment or under the seats",
      "Can never be left in a doorway or an aisle",
      "Should always be inspected by the driver as it is carried on the bus",
    ],
    answer: 1,
    explanation: "Carry-on baggage must never block doorways or aisles, which must remain clear for safe evacuation in an emergency.",
  },
  {
    id: "pa121",
    question: "You must sign the inspection report made by the previous driver only: (4.1.3)",
    options: [
      "When some of the repairs have not been made",
      "If the driver who filled out the report is present",
      "If the defects reported have been certified as repaired or not needing repair",
    ],
    answer: 2,
    explanation: "You must review and sign the previous driver's inspection report only after all defects have been certified as repaired or determined not to need repair before the vehicle is driven.",
  },
  {
    id: "pa122",
    question: "When you discharge an unruly rider, you should choose a place that is: (4.3.2)",
    options: [
      "Near a police station",
      "As safe as possible",
      "Convenient for you",
    ],
    answer: 1,
    explanation: "When discharging an unruly passenger, choose the safest available location — one that minimizes risk to the passenger, other riders, and the public.",
  },
  {
    id: "pa123",
    question: "How many folding seats are allowed in a bus that is not carrying farm workers? (4.1)",
    options: ["0", "4", "8"],
    answer: 0,
    explanation: "Folding (jump) seats are not permitted on buses unless the bus is specifically designed to transport farm workers, in which case special rules apply.",
  },
];

export default passenger;
